import { Typography, Alert } from 'antd';
import { HistoryOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
const { Text } = Typography;
const constants = {
	//API environment constants
	ApiUrl: process.env.REACT_APP_API_COMMON_URL,
	AdminApiUrl: process.env.REACT_APP_API_ADMIN_URL,
	StudentApiUrl: process.env.REACT_APP_API_STUDENT_URL,
	BaseUrl: process.env.REACT_APP_URLS_FOR_BASE,
	EnviromentName: process.env.REACT_APP_ENV,
	ContactRecaptcha: process.env.REACT_APP_SITE_KEY,
	//Page constants should be entered here.
	Home: "Home",
	Login: "Login",
	Logout: "Logout",
	Register: "Register",
	Logemanns: "Logemann's",
	EvalAndTrmnt: "Evaluation and Treatment of Swallowing Disorders",
	ThirdEdition: "Third Edition",
	BuyBook: "Buy Book",
	WelcomeBack: "Welcome back!",
	Username: "Username",
	Password: "Password",
	Help: "Help",
	Users: "Users",
	MyProfile: "My Profile",
	ContactUs: "Contact Us",
	Resources: "Resources",
	MyScores: "My Scores",
	Feedback: "Feedback",
	Codes: "Codes",
	AdminUsers: "Admin Users",
	StudentUsers: "Student Users",
	Acknowledgements: "Acknowledgements",
	NoAccount: "Don't have an account?",
	CreateAccount: "Create an account now!",
	ForgotPassword:"Forgot Password?",
	ChangePassword:"Change Password",
	SomethingWentWrong:"Something went wrong. Please try again.",
	BackHome: "Back to Home",
	WebsiteURL:"https://logemanndysphagia.com/",
	ProedPurchaseLink:"https://proedinc.com/products-40002.html",
	ProedPurchaseEbookLink:"https://proedinc.com/products-40002e.html",
	ShareTitleText:"Check this out!",
	ShareSubText:"Dive into the latest research and treatment approaches with Logemann's Evaluation and Treatment of Swallowing Disorders, Third Edition.",
	Tests:"Tests",
	TestScore:"Test Scores",
	Images:"Images",
	ImageQuizzes:"Image Quizzes",
	Videos:"Videos",
	Flashcards:"Flashcards",
	Dashboard:"Dashboard",
	MonthlyRegistration:"Monthly registration",
	YearlyRegistration:"Yearly registration",
	TopTenStates:"Top 10 US States",
	AllUSStates: "All US States",
	TopTenCountries:"Top 10 Countries",
	AllCountries: "All Countries",
	RoleAnalysis:"Role Analysis",
	UniversityAnalysis:"University Analysis",
	UniversityAnalysisSub:"(Top 10 US Universities)",
	AllUniversityAnalysisSub:"(US Universities)",
	ShowMore:"Show More...",
	ShowLess:"Show Less...",
	BackToHome:"<< Back To Home",
	FeedbackAnalysis: "Feedback Analysis",
	RegistrationsByStates: "Registrations by States (USA)",
	startDateOfTheYear : dayjs().startOf('year').format("YYYY-MM-DD"),
	endDateOfTheYear : dayjs().endOf('year').format("YYYY-MM-DD"),
	currentMonthSD: dayjs().startOf('month').format("YYYY-MM-DD"),
	currentMonthED: dayjs().endOf('month').format("YYYY-MM-DD"),
	lastMonthSD: dayjs().subtract(1, 'month').startOf('month').format("YYYY-MM-DD"), 
	lastMonthED: dayjs().subtract(1, 'month').endOf('month').format("YYYY-MM-DD"),
	lastThreeMonthED: dayjs().subtract(1, 'month').endOf('month').format("YYYY-MM-DD"), 
	lastThreeMonthSD: dayjs().subtract(3, 'month').startOf('month').format("YYYY-MM-DD"),
	currentMonthLastYearSD: dayjs().subtract(1, 'year').startOf('month').format("YYYY-MM-DD"), 
	currentMonthLastYearED: dayjs().subtract(1, 'year').endOf('month').format("YYYY-MM-DD"), 
	startDateOfTheLastYear : dayjs().subtract(1, 'year').startOf('year').format("YYYY-MM-DD"),
	endDateOfTheLastYear : dayjs().subtract(1, 'year').endOf('year').format("YYYY-MM-DD"),
	lastYearEndDate: dayjs().subtract(1, 'year').endOf('year').format("YYYY-MM-DD"),
	lastYearStartDate: dayjs("01/01/2020").format("YYYY-MM-DD"),
	lastthreemonthlastyearSD: dayjs().subtract(1, 'year').startOf('year').subtract(3, 'month').startOf('month').format("YYYY-MM-DD"),
	lastthreemonthlastyearED: dayjs().subtract(1, 'year').startOf('year').subtract(1, 'month').endOf('month').format("YYYY-MM-DD"),
	PreviousYears: "Previous Years",
	LastThreeMonthsLY: "Last 3 Months (Last Year)",
	ThisMonthLastYear: "This Month (Last Year)",
	LastThreeMonths: "Last 3 Months",
	LastMonth: "Last Month",
	ThisMonth: "This Month",
	LastYear: "Last Year",
	ThisYear: "This Year",
	NoDataFound: "No Data Found",
	PositiveFeedback: "Positive Feedback: ",
	NegativeFeedback: "Negative Feedback: ",
	OtherFeedback: "Other Feedback: ",
	//login
	InvalidLoginDetails: "Invalid login details",
	EnterPassword: "Enter Password",
	EnterUsername: "Enter Username",
	LogoutFailed: "Logout failed",

	//Forgot and Reset password
	ResetPassword: "Reset Password",
	PasswordChanged:"Password changed successfully. Click login to continue.",
	InvalidReset: "Invalid reset details.",
	NewPassword: "New Password",
	EnterNewPassword: "Enter New Password",
	ConfirmNewPassword: "Confirm New Password",
	RetypeNewPassword: "Re-type New Password",
	PasswordsDoNotMatch: "The two passwords that you entered do not match!",
	BackToLogin: "Back to Login",
	UsernameEmail: "Username/Email",
	EnterUserNameOrEmail: "Enter Username or Email",
	Submit: "Submit",
	Back: "Back",
	ConfirmPassword: "Confirm Password",
	SendInstruction: "Send Instructions",
	ForgotYourPassword: "Forgot your password? Don't Panic!",
	ForgotPasswordInstructions: "Enter either primary or alternate email address which you entered at the time of registration. Click Send Instructions button.",
	FPInstructionsSecond: "Then check your email Inbox (of either email account) for an email with further instructions. You will receive an email with a link to reset your password.",
	FPInstructionsThird: "If you do not find the email in your Inbox, check the Spam, Junk, or Promotions folders.",

	//Registration
	UsernameLengthValidation: "Username must be between 5 to 12 characters.",
	UsernameValidation: "Only letters (a-z), numbers (0-9), underscore (_) and dot (.) are allowed.",
	ErrorOccured: "An error occurred. Please try again.",
	OtherUniversityRegistration:"Enter University Name",
	EmailError: "An error occurred while validating emails",
	UsernameError: "An error occurred while validating username",
	PasswordTooltip: "Password length should be minimum 14 characters. It must contain at least 1 uppercase letter, 1 lowercase letter, a number, any special character.",
	EnterConfirmPassword: "Enter Confirm Password",
	Email: "Email",
	EnterEmail: "Enter Email",
	EmailTooltip: "All communication from this website will be sent to this email address.",
	AlternateEmail: "Alternate Email",
	EnterAlternateEmail: "Enter Alternate Email",
	AltEmailTooltip: "Provide an alternate email address. If you do not receive any emails from this website, your alternate email address will be used to contact you.",
	FirstName: "First Name",
	EnterFirstName: "Enter First Name",
	FirstNameInvalid:"Invalid First Name",
	LastName: "Last Name",
	EnterLastName: "Enter Last Name",
	LastNameInvalid:"Invalid Last Name",
	Role: "Role",
	RoleMessage: "Please enter Role",
	IAm: "I am a:",
	Occupation: "Occupation",
	EnterOccupation: "Enter Occupation",
	Country: "Country",
	SelectCountry: "Select a Country",
	University: "University",
	UniversityRegistration:"Select university",
	UniversityName: "University Name",
	EnterNumber: "Enter Contact Number",
	Number: "1(999)123-4567",
	BookCode: "Book Code",
	EnterCode: "Enter Book Code",
	InvalidCode: "Invalid Book Code",
	Code: "XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
	TermsUse: "Accept Terms of Use",
	TermsAndCondition: "I have read and agree to the Terms of Use.",
	AccountAlready: "Already have an account?",
	OtherOccupationValid: "Enter any occupation not displayed in the Role dropdown.",
	OtherUniversityExists:"University name already exists. Enter a new one.",
	BookCodeTooltip: "The print version of the book will include the access code inside the front cover. The e-book will include a link and an access code. Your subscription to the online resources (e.g. flashcards, online practice tests, etc.) will be valid for 1 year only from the date of registration. Enter the access code exactly as given in the book including the dashes (e.g. 12345-ABCDE-67890-FGHIJ-54321).",
	BookCodeRule: "Your subscription to the online resources (e.g. flashcards, online practice tests, etc.) will be valid for 1 year only from the date of registration.",
	UsernameTooltip: "Username must be unique, a single word, having between 5 to 12 characters. It can contain only letters (a-z, A-Z), numbers (0-9),  underscore (_) and dot (.).",
	EulaText: "I have read, agree with and understand the End User License Agreement.",
	PrivacyPolicyEducationalText: "I have read, agree with and understand the Educational Products Privacy Policy.",
	PrivacyPolicyHealthText: "I have read, agree with and understand the Health Care End User Privacy Policy.",
	Previous: "Previous",
	Next: "Next",

	//Code Generation
	CodeGeneration: "Code Generation",
	ReqField: "This field is required.",
	Duration: "Duration (In months)",
	NoOfCodes: "No of codes",
	Type: "Type",
	SelectType: "Select Type",
	PaymentMode: "Payment Mode",
	Cancel: "Cancel",
	Generate: "Generate",
	//Test Instructions
	Instructions: "Instructions",
	CommonInstruction: <Alert className='text-base' message={<>Before taking each test, clear the cache or browser history and do not enable 
	the private or incognito settings on your browser.<br/>
	 Then, close all browser windows, reopen the browser, and take a test.</>} type="warning" showIcon />,
	//Listing
	ChapterName:"Chapter",
	Definitions: 'Definitions',
	TotalNoOfQuestions: 'Total no. of questions',
	Diagnosis: 'Diagnosis',
	DiagnosisVideos: "Diagnosis Videos",
	pageSize:20,
	Description: 'Description',
	Qns: "Qns.",
	NoOfFlashcard: "Cards",
	//Profile
	Details: "Details",
	Close:"Close",
	Quit:"Quit",
	Save:"Save",
	Resume:"Resume",
	Ok:"Ok",
	OR:"OR",
	//Messages
	SelectOptionOnly:"Select an option.",
	SelectOptionOnlyTest:"Select an option or Mark for later.",
	LoggedInAnotherBrowser:"You have been automatically logged out. It appears that you may be logged in another browser.",
	PauseTestText: [
		<HistoryOutlined/>
	],
	PauseTestText2: [
		" now",
	],
	PauseTestText3:[
		"You may resume the Test at any time.",
	],
	Pause:"Pause",
	ClickHereTo:"Click here to",
	CompletedTestText:"You Have Completed The Test",
	CompleteTestText: [
		"Would you like to ",
	],
	CompleteTestText3:[
		" your answers once again?",
		<br/>,
		"You will be able to change your answers, if necessary",
	],
	CompleteTestText2: [
		" to view your results.",
		<br/>,
		"An analysis of your performance will also be displayed.",
	],
	PopupText:"You have marked question(s) for review.",
	PopupTextDescription:"Unanswered questions will be scored as incorrect.",
	PopupTextDescription2:"Click Ok to answer these question(s), or Cancel to submit the Test and display your Results.",
	SubmitTest:"Submit Test",
	ResumeTest:"Resume Test",
	StartTest:"Start Test",
	ReviewAll:"Review All",
	Profile: "My Profile",
	ValidTill: "Valid Till",
	ContactNumber: "Contact Number",
	//Activation
	Activation: "Account Activation",
	ActivationLinkGenerate:" to generate a new link for activation.",
	Here: "here",
	Click: "Click",
	ToLogin: " to Login.",
	//UsersList
	Admin: "Admin",
	Student: "Student",
	EditAdminUser: "Edit Admin User",
	EditStudentUser: "Edit Student User",
	Professional: "Professional",
	Faculty: "Faculty",
	Other: "Other",
	StartDate: "Start Date",
	Status: "Status",
	Active: "Active",
	NotActive: "Not Active",
	Pending: "Pending",
	Closed: "Closed",
	Cleared: "Cleared",
	Action: "Action",
	Name: "Name",
	State: "State",
	RegisteredOn: "Registered on",
	ValidUntil: "Valid until",
	Search: "Search",
	AdminUsersList: "Admin Users List",
	RegisteredStudents: "Registered Students",
	Showing: "Showing ",
	Of: " of ",
	Entries: " entries",
	FromTo: " to ",
	Reset: "Reset",
	Extend: "Extend",
	//Feedback
	RequiredCourse: "Required for a course",
	Recommended: "Recommended for a course",
	ThroughFriend: "Through a friend/colleague",
	ASHA: "ASHA conference",
	Amazon: "Amazon",
	Internet: "Internet",
	SocialMedia: "Social media",
	StateConference: "State conference",
	SendFeedback: "SEND US FEEDBACK",
	EnterOther: "Enter other option",
	ChooseOption: "Choose the appropriate option",
	Question1: "How did you hear about the book?",
	Question2: "The tests were challenging",
	Question3: "Overall rating of the entire product (book and website)",
	Agree: "Agree",
	Undecided: "Undecided",
	Disagree: "Disagree",
	Excellent: "Excellent",
	VeryGood: "Very Good",
	Good: "Good",
	Fair: "Fair",
	Poor: "Poor",
	Comments: "Comments...",
	EnterComment: "Enter comment",
	Required: "Required",
	Recommend: "Recommended",
	Friend: "Friend",
	Socials: "Socials",
	ASHA1: "ASHA",
	Conference: "Conference",
	//image-quiz-instruction
	Part4: <div className='text-base'>
		<h3 className="font-bold">About the test</h3>
		<p>You are allowed to take each image test three times.</p>
		<br/>
		<h3 className="font-bold">Taking the test</h3>
		<p>After selecting the appropriate choices from the drop down menu, press <Text mark>SUBMIT</Text>.</p>
		<br/>
		<h3 className="font-bold">After completing a test</h3>
		<p>All questions are equally weighted. Each label is worth 1 point. After clicking <Text mark>SUBMIT</Text> , you will see your total score.</p>
		<br/>
		<p>Click <Text mark>REVIEW INCORRECT</Text> to view your incorrect answers and the corresponding correct answers. Once you have reviewed all the incorrect answers, click <Text mark>QUIT</Text>.</p>
	</div>,
	PauseTest: "Pause Test",
	TotalTestsCount: 3,
	Check:"Check",
	Finish:"Finish",
	TestResult: "Test Result",
	Score: "Score",
	TestAttempts:"Test Attempts",
	//Student Dashboard
	Question: 'Question',
	Answer: 'Answer',
	Title: 'Title',
	ImageQuiz: "Image Quiz",
	QuestionUpdate: "Edit Question",
	Explanation: "Explanation",
	//Profile
  Upload: "Uplaod",
	InvalidFileFormat: "Invalid file format",
	//Contact Us
	FullName: "Full Name",
	EmailAddress: "Email Address",
	Subject: "Subject",
	Message: "Message",
	Send: "Send",
	EmailValidationMsg: "Enter valid email address",
	FullNameCheck: "Enter name",
	PhoneCheck: "Enter phone number",
	SubjectCheck:"Enter email subject",
	EmailCheck: "Enter email",
	SubmitAlert: "Are you sure you want to submit the quiz ?",
	QuizValidation: "Select your answer",
	QuestionViewMsg:"Go to Question list page",
	//Test Score
	Date: "Date",
	Attempt: "Attempt",
	Progress: "Progress",
	From: "From",
	To: "To",
	Clear: "Clear",
	Viewed:"Viewed",
	Reviewed: "Reviewed",
	Marked: "Marked",
	CheckAnswer: "Please select one answer",
	NotReviewed: "Not Reviewed",
	StudentView: "Student View",
	Attempt1: "Attempt 1",
	Attempt2: "Attempt 2",
	Attempt3: "Attempt 3",
	Completed: "Completed",
	InProgress: "In Progress",
	Paused: "Paused",
	//Tests
	Retake:"Retake",
	TestRemaining: "Test Remaining",
	//Image Quiz
	QuizRemaining: "Attempt Remaining",
	QuizzesRemaining: "Attempts Remaining",
	DateFormat : "MM/DD/YYYY",
	ReturnToScore: "Return to Score",
	ReviewTest: "Review Test",
	CloseSubTitleMessage: "Are you sure you want to Close?",
	ImagePreview: "Image Preview",
	StartQuiz: "Start Quiz",
	ImageQuizResult: "Image Quiz Result",
	ImageQuizAttempts: "Image Quiz Attempts",
	ViewResult: "View Result",
	//Flashcard View
	All: "All",
	Display: "Display",
	List: "List",
	DateFormat2 : "MM-DD-YYYY",
	TimeTaken: "Time Taken",
	DateFormat3: "YYYY-MM-DD",
	Chapter: "Chapter",
	//Review Incorrect
	YourAnswer: "Your Answer",
	CorrectAnswer: "Correct Answer",
	PausedOn: "Paused on",
	ResumeText:"(Continue with the test)",
	RestartText: "(Start the test again)",
	Preview: "Preview",
	Edit: "Edit",
	EditQuiz: "Edit Quiz",
	CodesErrMsg: "Failed to generate code",
	Quiz:"Quiz",
	EditContent: "Edit Content",
	BriefDescription: "Brief Description",
	Copyright : "Copyright",
	UploadCorrectImg: "Upload Image with Answers",
	UploadLabelImg: "Upload Image with Labels",
	//resend - activation
	ResendActivation: "Didn't receive the activation email?",
	ClickForResend: "Click here to resend it.",
	ResendActivationEmail: "Resend activation email",
	MessageActivationResend: "If you did not receive an email to activate your account, enter any one of the following details to receive an activation email again.",
	EmailValidationResend: "Not a valid Email!",
	Resendmail: "Resend Activation Email",
	ProedWebLink:"https://www.proedinc.com/",
	DateFormat4: "MMM D, YYYY",
	//Test score
	MyScoreBoard: "My Score Board",
	Noattemptstaken: "No attempts taken",
	AllPrevYear:"All Previous Years",
	//Video
	Age :"Age",
	ChiefComplaint : "Chief Complaint",
	DiagnosisAssoc : "Diagnosis associated with dysphagia",
	PriorHistory: "Prior History",
	DietAtTime: "Diet at time of evaluation",
	Findings: "Findings",
	EditFlashcard: "Edit Flashcard",
	CompleteReCaptcha:"Complete ReCaptcha",
	ReCaptchaFailed:"ReCaptcha Failed",
	FAQs: "FAQs",
	DownloadQuestionErrMsg: "Failed to download",
	ExportToWord:"Export to word",
	AccessOnlineResources: "How do I access the online resources?",
	FindAccessCode: "How do I find the access code to register for the online resources?",
	UseMyCode: "Can someone else use my subscription?",
	DidNotReceiveMail: "I did not receive an email after registration. What do I do?",
	NotReceivingMails: "I am not receiving emails from this site.",
	ForgettenUsernamePassword: "What should I do if I have forgotten my username or password?",
	AccAccessInfo: "How long will I be able to access my account?",
	CannotAccessOnlineResources: "What should I do if I cannot access the online resources?",
	Universities: "Universities",
	Custom: "Custom",
	LastUpdatedBy: "Last Updated By",
	LastUpdatedOn: "Last Updated On",
	UniversityMaster: "University Master",
	AddUniversity: "Add University",
	SelectState: "Select State",
	CannotLoginAccount: "Why can't I login to my account?",
	City: "City",
	Remove : "Remove",
	Add: "Add",
	Free: "Free",
	EBook: "E-Book",
	Book: "Book",
	Paid: "Paid",
	TypeOfBook: "Type of Book",
	//Video
	EditVideo: "Edit Video",
	CreatedOn: "Created on: ",
	UpdatedOn:" Updated on :",
	On: "on",
	UpdatedBy: "Updated by: ",
	Listing: "Listing",
	BookCodeList : "Book Code List",
	BookType: "Book Type",
	Available: "Available",
	Current: "Current",
	//Add Image Quiz
	AddQuiz: "Add Quiz",
	SelectAnImage: "Select an Image",
	ByRegistration: "By Registration",
	TestTaken: "Test Taken",
	Registered: "Registered",
	Valid: "Valid",
	Created: "Created",
	Booktype: "Book type",
	AddQuestion: "Add Question",
	AddFlashcard: "Add Flashcard",
	//Documents
	Documents: "Documents",
	Document: "Document",
	ValidFrom: "Valid From",
	Updatedby: "Updated By",
	EndUsers: "EULA",
	Effectivefrom: "Effective From",
	PrivacyPolicyEducational: "Educational Products Privacy Policy",
	PrivacyPolicyHealth: "Health Care End User Privacy Policy",
	EndUserLicenseAgreement: "End User License Agreement",
	PROEDPrivacyPolicies: "PRO-ED Privacy Policies",
	Policies: "Policies",
	//Image Quiz Scores
	ImageQuizScores:"Image Quiz Scores",
	QuizTaken: "Quiz Taken",
	//Change docs
	Effective: "effective from",
	FileName: "File Name",
	//SETTINGS
	Settings: "Settings",
	LastLoginDate: "Last Login Date",
	Lasttestattempted: "Last Test Attempted",
	LastImageQuizAttempted: "Last Image Quiz Attempted",
	Lastflashcardattempted: "Last Flashcard Attempted",
	Forgotpassword: "Forgot Password",
	//CRONS
	Cron: "Crons",
	CronActivity: "Cron Activity",
	//RESULT HISTORY
	Result: "Results",
	Activity: "Activity",
	//FLASHCARD ANALYSIS
	FlashcardAnalysis: "Flashcard Analysis",
	FlashcardTaken: "Flashcard Taken",
	Registrations: "Registrations",
	Export:"Export",
	InvalidName: "Invalid name format",
}
export default constants;